import React from 'react'
import Icon from '../../components/Icon'

const styleForIcon = { fontSize: 18, verticalAlign: 1, marginRight: 5 }

const Permissions = ({ collections, permissions, update }) => {

  let onChange = (key) => {
    if (hasPermission(key)) {
      permissions = permissions.filter(permission => permission !== key)
      update({
        permissions: [...permissions]
      })
    } else {
      update({
        permissions: [...permissions, key]
      })
    }
  }

  let hasPermission = name => {
    return permissions.indexOf(name) > -1
  }
  return (
    <div>
      <div className={'w-100'}>
        <div className={'d-flex flex-row'}>
          <div className={'py-2 pl-2 knacklyBlock d-flex'}>Catalog</div>
          <div className={'py-2 knacklyBlock d-flex'} style={{ width: 75 }}>Full Access</div>
        </div>
        {collections.map(({ name }) => (
          <div key={'permission-' + name} className={'d-flex flex-row'}>
            <div className={'knackly-plain py-2 pl-2 blockPermissions'}><Icon type={'icon-cabinet1'} style={styleForIcon}/>{name}</div>
            <div className={'knackly-plain py-2 blockPermissions'} style={{ width: 75 }}>
              <div className="form-check text-center p-0 m-0">
                <input className="form-check-input position-static p-0 m-0" type="checkbox"
                       onChange={() => onChange(name)} checked={hasPermission(name)}/>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>)

}

export default Permissions